import _ from "lodash";

function uuidv4() {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
    (
      c ^
      (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
    ).toString(16)
  );
}

function handleDataType(value) {
  if (_.isString(value)){
    return "STRING";
  }

  if (_.isUndefined(value)) {
    return "UNDEFINED";
  }

  if (_.isNull(value)) {
    return "NULL";
  }

  if (_.isNumber(value)){
    return "NUMBER";
  }

  if (_.isBoolean(value)) {
    return "BOOLEAN";
  }

  if (_.isArray(value)) {
    return "ARRAY";
  }

  if (_.isMap(value)) {
    return "MAP";
  }

  if (_.isNaN(value)) {
    return "NAN";
  }

  if (_.isWeakMap(value) || _.isWeakSet(value) || _.isSymbol(value) ) {
    return "COMPLEX_OBJECT";
  }

  if (_.isDate(value)) {
    return "DATE";
  }

  if (_.isFunction(value)) {
    return "FUNCTION";
  }

  if (_.isObject(value)) {
    return "OBJECT"
  }

  return "OBJECT";
} 

export { uuidv4, handleDataType };
